const PHOTO_ART_EDITOR = 'photo-art-editor/';

const EDITORS_LIST = [
  {
    id: 'enhance',
    label: 'Enhance',
    options: [
      { value: 'enhance-editor/?typeProduct=photo_restoration', label: 'Photo restoration' },
      { value: 'enhance-editor/?typeProduct=photo_colorization', label: 'Photo colorization' },
      { value: 'enhance-editor/?typeProduct=photo_retouching', label: 'Photo retouching' },
    ],
  },
  {
    id: 'digitize',
    label: 'Digitize',
    options: [
      { value: 'digitize-editor/?typeProduct=tape_transfer', label: 'Tape Transfer' },
      { value: 'digitize-editor/?typeProduct=photo_scan', label: 'Photo Scan' },
      { value: 'digitize-editor/?typeProduct=film_transfer', label: 'Film Transfer' },
      { value: 'digitize-editor/?typeProduct=digital_transfer', label: 'Digital Transfer' },
      { value: 'digitize-editor/?typeProduct=audio_transfer', label: 'Audio Transfer' },
    ],
  },
  {
    id: 'create',
    label: 'Create',
    options: [
      { value: PHOTO_ART_EDITOR, label: 'Photo art' },
    ],
  },
  {
    id: 'pages',
    label: 'Page',
    options: [
      { value: '/media-digitizing-service/', label: 'Digitize' },
      { value: '/convert-vhs-tapes-to-digital-dvd/', label: 'Tape Transfer' },
      { value: '/transfer-8mm-film-to-digital-dvd/', label: 'Film Transfer' },
      { value: '/convert-cassette-to-cd/', label: 'Audio Transfer' },
      { value: '/dvd-to-digital-service/', label: 'Digital Transfer' },
      { value: '/photo-scanning-service/', label: 'Photo Scanning' },
      { value: '/south-florida-media-digitizing-service/', label: 'South Florida Photo Scanning' },
      { value: '/south-florida-vhs-tape-transfer-service/', label: 'Local Tape Transfer' },
      { value: '/south-florida-film-transfer-service/', label: 'Local Film Transfer' },
      { value: '/south-florida-cassette-conversion-service/', label: 'Local Audio Transfer' },
      { value: '/south-florida-old-photo-scanning-service/', label: 'Local Photo Scanning' },
      { value: '/old-photo-restoration/', label: 'Photo Restoration' },
      { value: '/colorize-black-and-white-photos/', label: 'Photo Colorization' },
      { value: '/photo-retouching-service/', label: 'Photo Retouching' },
      { value: '/how-digitizing-and-enhancing-works/', label: 'How It Works' },
      { value: '/our-team/', label: 'Our Mission' },
      { value: '/our-story/', label: 'Our Story' },
      { value: '/gift-cards/', label: 'Gift Card' },
      { value: '/blog/', label: 'Blog' },
      { value: '/contact/', label: 'Contact' },
      { value: '/reviews/', label: 'Reviews' },
      { value: '/gift-guide/', label: 'Gift Guide' },
      { value: '/forever-cloud/', label: 'Forever Cloud' },
      { value: '/genealogy-document-photo-scanning-service/', label: 'Preserve' },
      { value: '/professional-media-archiving-printing/', label: 'Business Services' },
      { value: '/personalized-wall-art-books/', label: 'Story Art' },
      { value: '/print-on-demand/', label: 'Print On Demand' },
    ],
  },
];

const PRODUCT_PAGES = [
  { value: 'photo_art', label: 'Create page' },
  { value: 'photo_restoration', label: 'Photo restoration' },
  { value: 'photo_colorization', label: 'Photo colorization' },
  { value: 'photo_retouching', label: 'Photo retouching' },
  { value: 'proof', label: 'Proof page' },
];

export default {
  PHOTO_ART_EDITOR,
  EDITORS_LIST,
  PRODUCT_PAGES,
};
